export const INDENT = {
  BASE_TABLE: 58,
  PARENT_PORTFOLIO_CHILD: 76,
  PORTFOLIO_CONTENT: 50,
  TOTAL_NESTED: 108, // BASE_TABLE (58) + PORTFOLIO_CONTENT (50)
};

export const calculatePadding = (indentLevel) => {
  return indentLevel > 0
    ? `${INDENT.BASE_TABLE + indentLevel}px`
    : `${INDENT.BASE_TABLE}px`;
};

export const initiativeTypes = [
  'communication',
  'readiness',
  'training',
  'sustainment',
];
